import { Provider, useSelector } from "react-redux";
import { RouterProvider } from "react-router-dom";
import { router } from "../router.jsx";
import React, { useEffect } from "react";
import { configureStore } from "@reduxjs/toolkit";
import { uiSlice } from "../slices/uiSlice.jsx";
import { sessionSlice } from "../slices/sessionSlice.jsx";

function App() {
  let ui = useSelector((state) => state.ui);
  let session = useSelector((state) => state.session);

  let language =
    session.user?.language ||
    window.localStorage.language ||
    navigator.language.split("-")[0];

  if (!["en", "fr"].includes(language)) {
    language = "en";
  }

  useEffect(() => {
    let listener = (e) => {
      if (e.key === "Enter" && e.ctrlKey) {
        if (e.target.form)
          e.target.form.querySelector("button[type=submit]").click();
      }
    };
    document.addEventListener("keydown", listener);
    return () => document.removeEventListener("keydown", listener);
  }, []);

  return (
    <>
      <div
        className={
          "fixed bottom-0 right-0 flex text-white gap-3 mr-3 mb-3 flex-col"
        }
        style={{ width: 400, maxWidth: "100%", zIndex: 1000 }}
      >
        {ui.notifications.map(({ message, type, id }) => {
          return (
            <div
              className={
                "shadow p-3 rounded w-full " +
                (type === "danger" ? "bg-red-600" : "bg-blue-600")
              }
            >
              {message}
            </div>
          );
        })}
      </div>
      <RouterProvider router={router} />
    </>
  );
}

export function AppWrapper() {
  let store = configureStore({
    reducer: {
      ui: uiSlice.reducer,
      session: sessionSlice.reducer,
    },
  });

  return (
    <Provider store={store}>
      <App />
    </Provider>
  );
}
